import Error from '../components/common/Error';

const NotFound = () => {
  return (
    <Error
      message={'404 Not Found\n指定されたページは存在しません。'}
    />
  );
};

export default NotFound;
